import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const CATEGORY_LABELS = {
  kola: "Alu kola",
  kusovky: "Kusovky",
  pneu: "Pneumatiky",
  poklicky: "Pokličky",
  dily: "Autodíly",
};

export const BRANDS = [
  "Audi", "Volkswagen", "BMW", "Mercedes-Benz", "Škoda",
  "Seat / Cupra", "Lamborghini", "Ferrari", "Porsche",
];

export const TYRE_BRANDS = [
  "Pirelli", "Goodyear", "Michelin", "Continental", "Hankook", "Barum",
  "Bridgestone", "Dunlop", "Nokian", "Yokohama",
];

export const formatPrice = (n) =>
  new Intl.NumberFormat("cs-CZ").format(n) + " Kč";

export default api;
